import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import { isHighSchoolUrl, isHighSchoolDashboard } from 'utils/highschoolHelpers'
import {
  isDigitalWellBeingUrl,
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
  isK5Url,
  isK5Dashboard,
} from 'utils/routing/routeHelpers'
import { K12_CORE_CURRICULUM_SERVICE_FLAG } from 'utils/featureFlags'

import OffComponent from './flag.off'
import OnComponent from './flag.on'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20164-k5-site-selection',
    K12_CORE_CURRICULUM_SERVICE_FLAG,
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    // Only use flag.on (skipHsInstructorFetch) for HS when curriculum-service
    // v3 pages own the course-scoped LMS ensure. With the curriculum flag off,
    // HS must stay on flag.off/withSiteContextLegacy so prod still POSTs
    // instructor/me on page load via the nested site-selector HOC.
    const isHighSchoolCurriculum =
      (isHighSchoolUrl() || isHighSchoolDashboard()) &&
      !!subscribedFlags[K12_CORE_CURRICULUM_SERVICE_FLAG]

    const isMiddleSchool = isMiddleSchoolUrl() || isMiddleSchoolDashboard()

    const isK5 =
      (isK5Url() || isK5Dashboard()) &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return (
      isHighSchoolCurriculum ||
      isMiddleSchool ||
      isK5 ||
      isDigitalWellBeingUrl()
    )
  },
})

export default FlagToggler
